import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
/**
 * StudentDevGuard - Gates student-side routes behind a feature flag.
 *
 * Toggle this constant to enable/disable the student portal:
 * - true  = Student routes are accessible (development/testing)
 * - false = Student routes redirect to landing page (production)
 *
 * Usage: Wrap student-specific <Route> elements in App.tsx.
 */
// ============================================================
// 🔧 STUDENT PORTAL TOGGLE — Change this value to enable/disable
// ============================================================
const STUDENT_PORTAL_ENABLED = true;
// ============================================================
interface StudentDevGuardProps {
  children: React.ReactNode;
}
export const StudentDevGuard: React.FC<StudentDevGuardProps> = ({
  children
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!STUDENT_PORTAL_ENABLED) {
      console.log('[StudentDevGuard] Student portal disabled — redirecting to /');
      navigate('/', {
        replace: true
      });
    }
  }, [navigate]);
  if (!STUDENT_PORTAL_ENABLED) {
    return <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]" data-id="element-11315">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-deep-pink" data-id="element-11316"></div>
      </div>;
  }
  return <>{children}</>;
};
/** Helper to check the flag from other components (e.g. Navbar, HeroSection) */
export const isStudentPortalActive = (): boolean => {
  return STUDENT_PORTAL_ENABLED;
};